const UrbanIntelligenceSection = () => {
  return (
    <section className="bg-neutral-muted py-24 sm:py-32">
      <div className="mx-auto max-w-5xl px-6 lg:px-8">
        <div className="mb-12">
          <img
            src="/website/urban_intelligence.png"
            alt="Urban Intelligence"
            className="h-16 w-auto lg:h-28 md:-ml-5"
          />
        </div>

        <div className="space-y-8 text-lg leading-relaxed text-text-secondary lg:text-xl">
          <p>
            Located in Ōtautahi Christchurch, Aotearoa New Zealand, our work is underpinned by our
            cutting-edge research that develops approaches for data-driven climate adaptation
            planning, evidence-based risk, and resilience analysis.
          </p>

          <p>
            Since our inception in June 2021, our mission has been to support evidence-based
            decision-making so communities can adapt and become more resilient, healthy, and
            inclusive. Relying on our values, we have created a reputable organisation that
            approaches the pressures of climate change with an informed perspective, backed by a
            skilled and mission-driven team.
          </p>
        </div>
      </div>
    </section>
  )
}

export default UrbanIntelligenceSection
